module.exports = __webpack_public_path__ + "static/organicgreenleaf-4f9a82cc56924e566e2a0ada2fd14809.jpeg";